import {useRequest} from "../../../../__snowpack__/pkg/ahooks.js";
import request from "../../../utils/request/index.js";
export function useGetCompanyInfo() {
  const {runAsync: fetchCompany, data} = useRequest(() => {
    return request.get(`/infra/iam/account/company/get`, {});
  }, {
    manual: true
  });
  return {
    fetchCompany,
    data
  };
}
